var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ZimmerkontingenteWidget',{attrs:{"zimmerkontingente":_vm.params.data?.zimmerkontingente,"reiseterminId":_vm.params.data?.id,"isZvc":_vm.params.isZvc}})
}
var staticRenderFns = []

export { render, staticRenderFns }